/* ContentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { fg } from '@atlaskit/platform-feature-flags';
import { createEndAIExperienceCommand } from '../../../pm-plugins/decoration/actions';
import { getPluginState } from '../../../pm-plugins/decoration/decoration-plugin-factory';
import { hasGeneratedContentDecorations } from '../../../pm-plugins/decoration/utils/hasGeneratedContentDecorations';
import { useContentComponentContext } from '../../hooks/useContentComponentContext';
import { getAIHighlightPositions } from '../../utils/selection';
import { AgentFetcher } from '../AgentFetcher/AgentFetcher';
import { LoadableBrowseRovoAgentsModal } from '../BrowseRovoAgentsModal/BrowseRovoAgentsModal';
import { ExperienceApplication } from '../ExperienceApplication/ExperienceApplication';
import { ModalRegionErrorBoundary } from '../ExperienceApplicationErrorBoundary/ExperienceApplicationErrorBoundary';
import { GlobalWrapper } from '../GlobalWrapper/GlobalWrapper';
import { ModalRegion } from '../ModalRegion/ModalRegion';
import { PublishToRovo } from '../PublishToRovo/PublishToRovo';
import { RovoEnabled } from '../RovoEnabled/RovoEnabled';
import { SubscribeToRovo } from '../SubscribeToRovo/SubscribeToRovo';
export var ContentComponent = function ContentComponent() {
  var _useContentComponentC = useContentComponentContext(),
    aiOptIn = _useContentComponentC.aiOptIn,
    editorPluginAIProvider = _useContentComponentC.editorPluginAIProvider,
    editorView = _useContentComponentC.editorView,
    api = _useContentComponentC.api,
    wrapperElement = _useContentComponentC.wrapperElement,
    appearance = _useContentComponentC.appearance,
    providerFactory = _useContentComponentC.providerFactory,
    getMentionNameDetails = _useContentComponentC.getMentionNameDetails;
  var aiDecorationExperiencePluginState = useSharedPluginStateSelector(api, 'aiExperience.aiDecorationExperiencePluginState');
  var rovoAgentsPluginState = useSharedPluginStateSelector(api, 'aiExperience.rovoAgentsPluginState');
  var endExperience = function endExperience(options) {
    if (editorPluginAIProvider.onAIProviderChanged) {
      editorPluginAIProvider.onAIProviderChanged('command-palette');
    }
    var state = getPluginState(editorView.state);
    var decoSet = hasGeneratedContentDecorations(state) || options !== null && options !== void 0 && options.preserveEditorSelectionOnComplete ? state.modalDecorationSet : undefined;
    var endAIExperienceCommand = createEndAIExperienceCommand(decoSet, options === null || options === void 0 ? void 0 : options.preserveEditorSelectionOnComplete);
    endAIExperienceCommand(editorView.state, editorView.dispatch);
    editorView.focus();
  };

  // We use this point to render the modal if needed instead of decorators
  // The reason this is preferrable is it has access to mount points
  // where decorators are rendered with a mount point within the Editor content
  // and longer modals get clipped as a result.
  var renderModalRegion = function renderModalRegion() {
    var _api$engagementPlatfo;
    // If there are no active decorations -- then we don't want to render the ai experience.
    if (!aiDecorationExperiencePluginState || aiDecorationExperiencePluginState.modalDecorationSet === DecorationSet.empty) {
      return null;
    }
    if (hasGeneratedContentDecorations(aiDecorationExperiencePluginState)) {
      return null;
    }
    var modalDecorationElement = (editorView === null || editorView === void 0 ? void 0 : editorView.dom.querySelector('.ai-modal-end-widget')) || (editorView === null || editorView === void 0 ? void 0 : editorView.dom.querySelector('.ai-selection-node'));

    // This protects against cases where there is an active decoration
    // but the document has not been updated to include it
    if (!modalDecorationElement) {
      return null;
    }

    // Prioritise getting position from inlineDecoration,
    // otherwise get decoration position from start or end widget
    var positions;
    var decoration = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, function (spec) {
      return spec.key === 'inlineDecoration';
    }).shift() || aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, function (spec) {
      return spec.key === 'startWidgetDecoration' || spec.key === 'endWidgetDecoration';
    }).shift();
    if (decoration) {
      if (fg('platform_editor_ai_update_decorations_n_positions')) {
        // when there is decoration, it means it's text selection
        // we need to use the initial positions
        // as the decoration positions are not accurate when there the selection is empty
        if (!(aiDecorationExperiencePluginState !== null && aiDecorationExperiencePluginState !== void 0 && aiDecorationExperiencePluginState.initialPositions)) {
          return null;
        }
        positions = aiDecorationExperiencePluginState === null || aiDecorationExperiencePluginState === void 0 ? void 0 : aiDecorationExperiencePluginState.initialPositions;
      } else {
        positions = [decoration.from, decoration.to];
      }
    } else {
      var nodeDecorations = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, function (spec) {
        return spec.key === 'ai-nodeDecoration';
      });
      if (nodeDecorations.length > 0) {
        var startPos = Math.min.apply(Math, _toConsumableArray(nodeDecorations.map(function (decoration) {
          return decoration.from;
        })));
        var endPos = Math.max.apply(Math, _toConsumableArray(nodeDecorations.map(function (decoration) {
          return decoration.to;
        })));
        positions = [startPos, endPos];
      }
      decoration = nodeDecorations.shift();
    }
    if (!decoration) {
      return null;
    }
    return /*#__PURE__*/React.createElement(ModalRegion, {
      lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
      key: aiDecorationExperiencePluginState.modalMountedTimeStamp,
      decoration: decoration,
      modalDecorationElement: modalDecorationElement,
      editorView: editorView,
      editorRelativeWrapper: wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.offsetParent,
      endExperience: endExperience,
      appearance: appearance,
      decorationSet: aiDecorationExperiencePluginState.modalDecorationSet
    }, aiDecorationExperiencePluginState.configItem && editorView && /*#__PURE__*/React.createElement(ExperienceApplication, {
      configItem: aiDecorationExperiencePluginState.configItem,
      editorPluginAIProvider: editorPluginAIProvider,
      endExperience: endExperience
      // Ignored via go/ees005
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ,
      positions: positions,
      editorView: editorView,
      providerFactory: providerFactory,
      lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
      triggerMethod: aiDecorationExperiencePluginState.triggerMethod,
      appearance: appearance,
      initialPrompt: aiDecorationExperiencePluginState === null || aiDecorationExperiencePluginState === void 0 ? void 0 : aiDecorationExperiencePluginState.initialPrompt,
      getMentionNameDetails: getMentionNameDetails,
      triggeredFor: aiDecorationExperiencePluginState.triggeredFor,
      engagementPlatformApi: api === null || api === void 0 || (_api$engagementPlatfo = api.engagementPlatform) === null || _api$engagementPlatfo === void 0 ? void 0 : _api$engagementPlatfo.actions,
      initialPositions: aiDecorationExperiencePluginState === null || aiDecorationExperiencePluginState === void 0 ? void 0 : aiDecorationExperiencePluginState.initialPositions,
      nudgeMetrics: aiDecorationExperiencePluginState.nudgeMetrics
    }));
  };
  var getPositions = function getPositions() {
    return getAIHighlightPositions({
      modalDecorationSet: aiDecorationExperiencePluginState === null || aiDecorationExperiencePluginState === void 0 ? void 0 : aiDecorationExperiencePluginState.modalDecorationSet
    });
  };
  var renderedSubscribeToRovo = /*#__PURE__*/React.createElement(SubscribeToRovo, {
    positions: getPositions(),
    editorView: editorView,
    product: editorPluginAIProvider.product,
    onDocChangeByAgent: editorPluginAIProvider.onDocChangeByAgent,
    onAIProviderChanged: editorPluginAIProvider.onAIProviderChanged,
    editorPluginAIProvider: editorPluginAIProvider
  });
  return /*#__PURE__*/React.createElement(GlobalWrapper, null, /*#__PURE__*/React.createElement(RovoEnabled, {
    editorView: editorView,
    editorPluginAIProvider: editorPluginAIProvider
  }, /*#__PURE__*/React.createElement(PublishToRovo, {
    editorView: editorView,
    getMentionNameDetails: getMentionNameDetails,
    editorPluginAIProvider: editorPluginAIProvider,
    editorApi: api
  }), /*#__PURE__*/React.createElement(AgentFetcher, {
    editorPluginAIProvider: editorPluginAIProvider,
    editorView: editorView
  }), renderedSubscribeToRovo), /*#__PURE__*/React.createElement(ModalRegionErrorBoundary, {
    onCloseFallback: endExperience
  }, renderModalRegion(), (rovoAgentsPluginState === null || rovoAgentsPluginState === void 0 ? void 0 : rovoAgentsPluginState.isBrowseModalOpen) && /*#__PURE__*/React.createElement(LoadableBrowseRovoAgentsModal, {
    editorView: editorView,
    aiGlobalOptIn: aiOptIn,
    editorPluginAIProvider: editorPluginAIProvider,
    startingConfig: aiDecorationExperiencePluginState === null || aiDecorationExperiencePluginState === void 0 ? void 0 : aiDecorationExperiencePluginState.configItem,
    positions: rovoAgentsPluginState === null || rovoAgentsPluginState === void 0 ? void 0 : rovoAgentsPluginState.positions
  })));
};